module.exports = __webpack_public_path__ + "img/infographic_terms_increasing.70e4d3c4.gif";